import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { StoneInventory } from '@stone/interfaces';

interface InventoryState {
  items: StoneInventory[];
  totalCount: number;
  loading: boolean;
  saving: boolean;
  error: string | null;
}

const initialState: InventoryState = {
  items: [],
  totalCount: 0,
  loading: false,
  saving: false,
  error: null,
};

const inventorySlice = createSlice({
  name: 'stone.inventory',
  initialState,
  reducers: {
    fetchInventoryRequest: (state, _action: PayloadAction<any>) => {
      state.loading = true;
      state.error = null;
    },
    fetchInventorySuccess: (state, action: PayloadAction<{ items: StoneInventory[]; totalCount: number }>) => {
      state.items = action.payload.items;
      state.totalCount = action.payload.totalCount;
      state.loading = false;
    },
    fetchInventoryFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    saveStoneRequest: (state, _action: PayloadAction<any>) => {
      state.saving = true;
      state.error = null;
    },
    saveStoneSuccess: (state) => {
      state.saving = false;
    },
    saveStoneFailure: (state, action: PayloadAction<string>) => {
      state.saving = false;
      state.error = action.payload;
    },
  },
});

export const { fetchInventoryRequest, fetchInventorySuccess, fetchInventoryFailure, saveStoneRequest, saveStoneSuccess, saveStoneFailure } =
  inventorySlice.actions;
export default inventorySlice.reducer;
